<template>
  <div class="ecm__navbar-bottom">
    <div class="ecm__navbar-bottom__links">
      <button class="ecm__navbar-bottom__links-link" @click=" () => {
          $router.push('/books')
            .catch(() => {})
        }">
        Books
      </button>
      <el-popover
        v-for="(link) in navLinks"
        :key="link.key"
        class="ecm__navbar-bottom__links-link"
        placement="bottom"
        v-model="link.isOpen"
        >
        <div class="ecm__navbar-bottom__links-link__content">
          <div class="ecm__navbar-bottom__links-link__content-data"
            v-loading="link.contents.length == 0"
          >
            <div class="ecm__navbar-bottom__links-link__content-data__item"
              v-for="(content) in link.contents"
              :key="content.id"
            >
              <p @click="handleOption(link.value, content.name, link.key)">{{ content.name }}</p>
            </div>
          </div>
        </div>
        <el-button slot="reference">
          {{ link.value }}
          <i v-if="link.isOpen" class="fas fa-chevron-up active"></i>
          <i v-else class="fas fa-chevron-down"></i>
        </el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'BottomNavbar',
  data () {
    return {
      navLinks: [
        {
          key: 'category',
          value: 'Category',
          isOpen: false,
          contents: []
        },
        {
          key: 'author',
          value: 'Author',
          isOpen: false,
          contents: []
        },
        {
          key: 'publisher',
          value: 'Publisher',
          isOpen: false,
          contents: []
        }
      ]
    }
  },
  mounted () {
    this.formatNavLinks()
  },
  computed: {
    ...mapState({
      categories: state => state.category.categories,
      authors: state => state.author.authors,
      publishers: state => state.publisher.publishers
    })
  },
  methods: {
    ...mapActions({
      getCategories: 'category/fetchCategories',
      getAuthors: 'author/fetchAuthors',
      getPublishers: 'publisher/fetchPublishers'
    }),
    formatNavLinks () {
      this.getCategories()
      this.getAuthors()
      this.getPublishers()
      setTimeout(() => {
        this.$data.navLinks.forEach((element, i) => {
          if (element.key === 'category') {
            this.$data.navLinks[i].contents = this.categories
          } else if (element.key === 'author') {
            this.$data.navLinks[i].contents = this.authors
          } else if (element.key === 'publisher') {
            this.$data.navLinks[i].contents = this.publishers
          }
        })
      }, 1000)
    },  
    handleOption (linkValue, contentName, key) {
      let query = ''
      switch (key) {
        case 'category':
          query = `?category=${contentName}`
          break
        case 'author':
          query = `?author=${contentName}`
          break
        case 'publisher':
          query = `?publisher=${contentName}`
          break
        default:
          query = ''
          break
      }
      this.$router.push(`/books${query}`)
        .catch((e) => {})
      this.setOpenDropDown(key)
    },
    setOpenDropDown (key) {
      this.$data.navLinks = this.$data.navLinks.map(item => {
        if (item.key === key) {
          item.isOpen = !item.isOpen
        } else {
          item.isOpen = false
        }
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__navbar-bottom {
  padding: 0 2rem;
  display: flex;
  align-items: center;
}
.ecm__navbar-bottom {
  flex: 1;
  justify-content: center;
  background: var(--color-yellow);
  .ecm__navbar-bottom__links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ecm__navbar-bottom__links-link {
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: -0.5px;
      cursor: pointer;
      color: #21325E;
      letter-spacing: 0.5px;
      border: none;
      background: var(--color-yellow);
      outline: none;
      margin-right: 10px;
      &:first-child {
        width: 150px;
      }
      ::v-deep .el-button {
        width: 100%;
        height: 100%;
        line-height: 0;
        padding: 0;
        border: none;
        outline: none;
        font-size: inherit;
        color: inherit;
        background: inherit;
        text-transform: uppercase;
        height: 20px;
        width: 150px;
        font-weight: 600;
        i {
          margin-left: 2px;
          &.active {
            color: var(--color-blue-background);
            font-weight: 700;
          }
        }
        &:hover {
          background: none;
        }
        &:focus {
          background: none;
        }
      }
    }
  }
}
</style>